

import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";


//import filter modal
import FilterModal from "../../components/Modal/FilterModal.js";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  putRequestForm,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";








const ManufactureDocument = ({document}) => {
 
    const [loader, setLoader] = useState(true);

console.log({document})

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
      }


      function ProductFormatter(cellContent, row) {
        return (
          <>
            <img
              src={row?.documentImage}
            //   onClick={() => showLightBox(row.documentImage)}
              alt="Not found Product"
              width={"50px"}
            />
          </>
        );
      }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
        dataField: "documentId",
        text: "Document Id",
        sort: false,
      },

    {
      dataField: "documentType",
      text: "Document Type",
      sort: false,
    },
    {
    
      text: "Document Image",
      formatter: ProductFormatter,
      sort: false,
    },
  
  ];


  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/product-details`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-eye text-light"></i>
            </Link>{" "}
          </button>
          {/* <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/addReply/${row._id}`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-reply fs-5 text-light"></i>
            </Link>{" "}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handlerdelete(row._id)}
          >
            <i class="fal fa-trash  fs-5"></i>
          </button> */}
          &nbsp;&nbsp;
        </div>
      </React.Fragment>
    );
  }

  
  
  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          {/* <Col className="12">
            <div className="page-title-box">
              <h4>Hotel Product Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Product Management</li>:{" "}
                <li className="breadcrumb-item">Product List</li>
              </ol>
            </div>
          </Col> */}

          <Col className="col-12">
            <Card>
            <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                     
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={document}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                             

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                       
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
            </Card>
          </Col>
        </Row>
        
      </React.Fragment>
 
    </>
  );
};

export default ManufactureDocument;
